import { render, staticRenderFns } from "./dissertation-project-edit.pug?vue&type=template&id=98bd637c&lang=pug&"
import script from "./dissertation-project-edit.ts?vue&type=script&lang=ts&"
export * from "./dissertation-project-edit.ts?vue&type=script&lang=ts&"
import style0 from "./dissertation-project-edit.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports